import { useContext } from 'react';
import { AccountAndBillingContext, AccountAndBillingContextValue } from './AccountAndBillingContext';

export default function useAccountAndBilling(): AccountAndBillingContextValue {
  const value = useContext(AccountAndBillingContext);

  if (!value) {
    throw new Error(
      "useAccountAndBilling: used outside the Account & Billing feature root. Only the feature's own components and hooks may call it — a standalone leaf (table, search form, drawer) takes viewer/account/permissions as props instead.",
    );
  }

  return value;
}
